export default class FormatHelper {
	static formatMoneyNumber(number) {
		return 'R$ ' + parseFloat(number).toFixed(2).replace(".", ",");
	}
}
